// removed by extract-text-webpack-plugin
module.exports = {"root":"order-grid--root--1kQxnQZf","columns1":"order-grid--columns1--2cVBMDAd","columns2":"order-grid--columns2--2k2iAZ3-"};


//////////////////
// WEBPACK FOOTER
// ./components/order-grid/styles.css
// module id = ./components/order-grid/styles.css
// module chunks = 0